import * as React from 'react';
import { SVGProps } from 'react';

const IconWatchFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm1-8.512V2.002H7V8.53l4.437 3.106 1.147-1.639L9 7.488z"
    />
  </svg>
);
export default IconWatchFilledSizeS;
